module.exports = __webpack_public_path__ + "img/banner.59e507f6.jpg";